
import { defineComponent } from 'vue';
import QuestionarePartContainer from '@/containers/Questionare/QuestionarePartContainer.vue';
import '@/styles/main.scss';

export default defineComponent({
  name: 'Home',
  components: {
    QuestionarePartContainer,
  },
});
